import React from "react";
//Importing Pages
import AboutUs from "./pages/AboutUs";
import Nav from "./pages/Nav";
import OurWork from "./pages/OurWork";
import ContactUs from "./pages/ContactUs";
import MovieDeatail from "./pages/MovieDetail";
//importing global style
import GlobalStyle from "./components/GlobalStyles";
//Router
import { Switch, Route, useLocation } from "react-router-dom";
//Animation
import { AnimatePresence } from "framer-motion";
function App() {
  const location = useLocation();
  return (
    <div className="App">
      <GlobalStyle />
      <Nav />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route path="/work" exact>
            <OurWork />
          </Route>
          <Route path="/" exact>
            <AboutUs />
          </Route>
          <Route path="/work/:id">
            <MovieDeatail />
          </Route>
          <Route path="/contact">
            <ContactUs />
          </Route>
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;
